import {
  // GET_STORE_CHECKS_SUCCESS,
  UPDATE_STORE_CHECKS,
  DELETE_CHECK,
  CLEAR_CHECKS,
  UPDATE_STORE_CHECK_PREPS,
  DELETE_CHECK_PREP
} from '@reducers/storeChecks';
import {
  UPDATE_STORE_NOTIFICATIONS,
  REMOVE_STORE_NOTIFICATION,
  CLEAR_NOTIFICATION
} from '@reducers/storeNotifications';
import store from '../store';
import { flowType } from '@utility/userInfo';

// eslint-disable-next-line import/prefer-default-export
export const subscribe = (message) => {
  if (flowType() != 'kds') {
  switch (message.messageType) {
    // check was added or updated
    case 'CheckAdded':
    case 'CheckUpdated': {
      store.dispatch({
        type: UPDATE_STORE_CHECKS,
        payload: message.checkHeader
      });
      break;
    }
    // check was deleted
    case 'CheckDeleted': {
      store.dispatch({
        type: DELETE_CHECK,
        payload: message
      });
      break;
    }
    // all checks for the store were cleared/deleted
    case 'ChecksCleared': {
      store.dispatch({
        type: CLEAR_CHECKS,
      });
      break;
    }
    case 'NotificationAdded':
    case 'NotificationUpdated': {
      store.dispatch({
        type: UPDATE_STORE_NOTIFICATIONS,
        payload: message.notification
      });
      break;
    }
    // check was deleted
    case 'NotificationDeleted': {
      store.dispatch({
        type: REMOVE_STORE_NOTIFICATION,
        payload: message.notificationId
      });
      break;
    }
    // all checks for the store were cleared/deleted
    case 'NotificationsCleared': {
      store.dispatch({
        type: CLEAR_NOTIFICATION,
      });
      break;
    }
    default:
      console.info('No check subscription');
      break;
  }
  } else {
    switch (message.messageType) {
      // check was added or updated
      case 'CheckPrepAdded':
      case 'CheckPrepUpdated': {
        store.dispatch({
          type: UPDATE_STORE_CHECK_PREPS,
          payload: message
        });
        break;
      }
      // check was deleted
      case 'CheckPrepDeleted': {
        store.dispatch({
          type: DELETE_CHECK_PREP,
          payload: message
        });
        break;
      }
      // all checks for the store were cleared/deleted
      case 'ChecksCleared': {
        store.dispatch({
          type: CLEAR_CHECKS,
        });
        break;
      }
      case 'NotificationAdded':
      case 'NotificationUpdated': {
        store.dispatch({
          type: UPDATE_STORE_NOTIFICATIONS,
          payload: message.notification
        });
        break;
      }
      // check was deleted
      case 'NotificationDeleted': {
        store.dispatch({
          type: REMOVE_STORE_NOTIFICATION,
          payload: message.notificationId
        });
        break;
      }
      // all checks for the store were cleared/deleted
      case 'NotificationsCleared': {
        store.dispatch({
          type: CLEAR_NOTIFICATION,
        });
        break;
      }
      default:
        console.info('No check subscription');
        break;
    }
  }
};
